import { Client } from '@stomp/stompjs';
import Auth from '@/common/auth';
var DESTINATION = '/user/queue/global-commbook';
function socketUrl() {
    var scheme = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    var prefix = process.env.NODE_ENV === 'production' ? '' : '/classnovo';
    return "".concat(scheme, "//").concat(window.location.host).concat(prefix, "/commbook/global/realtime");
}
/** The socket carries only invalidation hints. All message data comes from authenticated HTTP APIs. */
export function connectCommbookRealtime(onChange) {
    var sessionIdentity = Auth.getSessionIdentity();
    if (!Auth.isSessionCurrent() || !Auth.getToken())
        return function () { return undefined; };
    var stopped = false;
    var retries = 0;
    var client = new Client({
        brokerURL: socketUrl(),
        reconnectDelay: 1000,
        heartbeatIncoming: 20000,
        heartbeatOutgoing: 20000,
        beforeConnect: function () {
            if (!Auth.isSessionCurrent() || sessionIdentity !== Auth.getSessionIdentity()) {
                stopped = true;
                void client.deactivate();
                return;
            }
            var token = String(Auth.getToken() || '')
                .trim()
                .replace(/^Bearer\s+/i, '');
            client.connectHeaders = { Authorization: "Bearer ".concat(token) };
        },
        onConnect: function () {
            if (stopped || !Auth.isSessionCurrent() || sessionIdentity !== Auth.getSessionIdentity()) {
                void client.deactivate();
                return;
            }
            retries = 0;
            client.reconnectDelay = 1000;
            client.subscribe(DESTINATION, function (message) {
                if (stopped)
                    return;
                if (!Auth.isSessionCurrent() || sessionIdentity !== Auth.getSessionIdentity()) {
                    stopped = true;
                    void client.deactivate();
                    return;
                }
                try {
                    if (JSON.parse(message.body).type === 'CHANGED')
                        onChange('changed');
                }
                catch (_error) {
                    // A malformed hint must not replace the authenticated HTTP source of truth.
                }
            });
            // Let the page combine its first subscription with initialization; reconnects still catch up.
            onChange('connected');
        },
        onWebSocketClose: function () {
            retries += 1;
            client.reconnectDelay = Math.min(30000, 1000 * Math.pow(2, Math.min(retries, 5)));
        },
        onStompError: function () {
            // Invalid credentials/permissions are not transient. The HTTP fallback stays active.
            void client.deactivate();
        }
    });
    var onStorage = function () {
        if (!Auth.isSessionCurrent() || sessionIdentity !== Auth.getSessionIdentity()) {
            stopped = true;
            void client.deactivate();
        }
    };
    window.addEventListener('storage', onStorage);
    client.activate();
    return function () {
        stopped = true;
        window.removeEventListener('storage', onStorage);
        void client.deactivate();
    };
}
